import React from "react";
import {Page} from "../../components/page/page";
import styles from "./about-you.module.css";
import {useSelector} from "react-redux";

const options = [
    {
        value: "Build a strong, loving relationship",
        icon: "💖",
    },
    {
        value: "Gain clarity in decision-making",
        icon: "🔍",
    },
    {
        value: "Achieve success in career & personal life",
        icon: "🚀",
    },
    {
        value: "Find happiness",
        icon: "😊",
    },
    {
        value: "Achieve financial freedom",
        icon: "💸",
    },
];

const AboutYouPage = () => {
    const state = useSelector((store) => store.future);

    return (
        <Page
            title={[<span>{state.zodiacSign}</span>, " you deeply care about others and often think outside the box"]}
            nextPageLink="../analyzing-profile"
            currentStep="21"
        >
            <p className={styles.subtitle}>ZodiaQ will help you:</p>
            <ul className={styles.list}>
                {options.map((option, i) => (
                    <li key={i}>
                        <div className={styles.container_advantages}>
                            <span>{option.icon}</span>
                            <p>{option.value}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </Page>
    );
};

export {AboutYouPage};
